import { Stack, TextField, Typography } from "@mui/material";

interface Props {
  label: string;
  from?: string;
  to?: string;
  onFromChange: (value: string) => void;
  onToChange: (value: string) => void;
}

export function QuoteDateRangeFilter(props: Props) {
  const { label, from = "", to = "", onFromChange, onToChange } = props;

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography
        variant="body2"
        sx={{ width: 60, fontWeight: 500, flexShrink: 0 }}
      >
        {label}
      </Typography>
      <TextField
        label="From"
        type="date"
        value={from}
        inputProps={{ max: to || undefined }}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => onFromChange(e.target.value)}
        sx={{ flex: 1 }}
      />
      <Typography variant="body2" color="text.secondary">
        –
      </Typography>
      <TextField
        label="To"
        type="date"
        value={to}
        inputProps={{ min: from || undefined }}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => onToChange(e.target.value)}
        sx={{ flex: 1 }}
      />
    </Stack>
  );
}
